import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Base } from "components/template";
import { InputControl } from "components/organism";
import { newPasswordSchema } from "_config/formSchemas";
import { useLocalStorage } from "_hooks";
import { createPassword } from "_config/store/account/account.thunk";
import { Button } from "components/atoms";
import { useEffect } from "react";
import { ProgressBar } from "components/molecules";

const prefix = "v-createPassword";

const CreatePassword = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [obEmail, setOBEmail] = useLocalStorage("OBEmail");
  const { formState: { errors, dirtyFields }, handleSubmit, register, trigger, watch  } = useForm({
    resolver: yupResolver(newPasswordSchema),
    mode: "onChange"
  });
  const { data: response, isLoading } = useSelector((s) => s.account.createPassword);
  
  const watchFields = watch();

  const onSubmit = ({ password }) => {
    dispatch(createPassword({
      email: obEmail,
      password
    }));
  };

  useEffect(() => {
    if (response !== null) {
      setOBEmail(response?.email);
      
      setTimeout(() => {
        navigate("/account/userData", { state });
      }, 100);
    }
  
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base
      align="normal"
      header={<ProgressBar max={6} progress={2} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3">
          <p className="text-center text-2xl font-bold mx-auto mb-10">Crea tu contraseña</p>

          <form 
            className="flex flex-wrap gap-3"
            onSubmit={handleSubmit(onSubmit)}
          >
            <InputControl
              errors={errors?.password}
              inputProps={{
                type: "password",
                ...register("password")
              }}
              name="password"
              label={"Nueva contraseña"}
              onChange={() => {
                trigger(["password"]);
                if (dirtyFields?.confirm) trigger(["confirm"])
              }}
              orientation="vertical"
              showErrors={false}
            />

            <InputControl
              errors={errors?.confirm}
              className="mb-5"
              inputProps={{
                type: "password",
                ...register("confirm")
              }}
              label={"Confirmar nueva contraseña"}
              name="confirm"
              onChange={() => {
                if (dirtyFields?.password) trigger(["confirm"])
              }}
              orientation="vertical"
              showErrors={false}
            />

            <div className={`${prefix}__rules mb-5`}>
              <ul className="list-disc list-inside">
                <li
                  className={dirtyFields?.password && dirtyFields?.confirm && `text-${watchFields?.password === watchFields?.confirm ? "green-500": "red-700"}`}
                >
                  Las contraseñas coinciden
                </li>
                <li
                  className={dirtyFields?.password && `text-${/.{8,}$/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene al menos 8 caracteres</li>
                <li className={dirtyFields?.password && `text-${/(?=.*[0-9])/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene un número (0-9)</li>
                <li className={dirtyFields?.password && `text-${/(?=.*[#/¡!-.¿?])/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene un caracter especial (#/¡!-.¿?)</li>
              </ul>
            </div>
            
            <Button 
              className="bg-primary text-white rounded-lg"
              disabled={isLoading || !!Object.keys(errors).length}
              fullwidth
              pulse={true}
              spin={isLoading}
              type="submit"
            >Continuar</Button>

          </form>
        </div>
      </div>
    </Base>
  );
};

export default CreatePassword;
